const API_BASE = process.env.REACT_APP_API_URL || '';

async function request(endpoint, options = {}) {
  const res = await fetch(`${API_BASE}${endpoint}`, {
    credentials: 'include',
    ...options,
  });
  if (!res.ok) {
    const error = new Error(res.statusText);
    error.status = res.status;
    throw error;
  }
  return res.json();
}

export const api = {
  get: (endpoint) => request(endpoint),
  
  post: (endpoint, data) => request(endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  }),
  
  patch: (endpoint, data) => request(endpoint, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  }),
  
  put: (endpoint, data) => request(endpoint, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  }),
  
  delete: (endpoint) => request(endpoint, { method: 'DELETE' }),
  
  upload: (endpoint, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return fetch(`${API_BASE}${endpoint}`, {
      method: 'POST',
      credentials: 'include',
      body: formData,
    }).then(res => {
      if (!res.ok) throw new Error('Upload failed');
      return res.json();
    });
  },
};

// Legacy exports for existing code - migrate screens to use api.* over time
export const uploadReceipt = (file) => api.upload('/receipts/upload', file);
export const createManualEntry = (data) => api.post('/receipts/manual', data);
export const updateReceipt = (id, data) => api.patch(`/receipts/${id}`, data);
export const getCategories = () => api.get('/categories');
export const getBudget = (year, month, userId) => {
  let url = '/budget';
  const params = [];
  if (year && month) params.push(`year=${year}`, `month=${month}`);
  if (userId) params.push(`user_id=${userId}`);
  if (params.length) url += '?' + params.join('&');
  return api.get(url);
};

export const importStatement = (items, userId) =>
  api.post(`/receipts/statement/import?user_id=${userId}`, { items });

// Mortgage
export const getMortgage = () => api.get('/mortgage');
export const createMortgage = (data) => api.post('/mortgage', data);
export const updateMortgage = (data) => api.patch('/mortgage', data);
export const getMortgagePayments = () => api.get('/mortgage/payments');
export const logMortgagePayment = (data, userId) => api.post(`/mortgage/payments?user_id=${userId}`, data);
export const updateMortgagePayment = (id, data) => api.patch(`/mortgage/payments/${id}`, data);
export const deleteMortgagePayment = (id, deleteReceipt = false) =>
  api.delete(`/mortgage/payments/${id}?delete_receipt=${deleteReceipt}`);

// Mortgage Rate Periods
export const getMortgageRates = () => api.get('/mortgage/rates');
export const addMortgageRate = (data) => api.post('/mortgage/rates', data);
export const updateMortgageRate = (id, data) => api.patch(`/mortgage/rates/${id}`, data);
export const deleteMortgageRate = (id) => api.delete(`/mortgage/rates/${id}`);

export { API_BASE };
